import api from "../components/api";
import { openDB } from "./indexedDb";

export async function syncVitals() {
  console.log("🔄 syncVitals started");

  const db = await openDB();

  // 1️⃣ Get records in readonly transaction
  const readTx = db.transaction("vitals", "readonly");
  const readStore = readTx.objectStore("vitals");
  const index = readStore.index("synced");

  const records = await new Promise((resolve, reject) => {
    const req = index.getAll(0);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });

  console.log("📦 Unsynced vitals count:", records.length);

  for (const record of records) {
    try {
      const payload = {
        technician_id: record.technician_id,
        service_id: record.service_id, // make sure numeric
        height: record.height,
        weight: record.weight,
        bp: record.bp,
        pulse: record.pulse,
        oxygen_saturation: record.oxygen_saturation,
        body_temperature: record.body_temperature,
        inhale: record.inhale,
        exhale: record.exhale,
        abdomen: record.abdomen,
        general_condition: record.general_condition
      };

      payload.patient_excel_id = record.patient_excel_id.replace(/\s+/g, "").trim();

      console.log("📤 Sending vitals payload:", payload);

      await api.post("/technician/vitals/", payload);

      // 2️⃣ New write transaction AFTER API success
      const writeTx = db.transaction("vitals", "readwrite");
      const writeStore = writeTx.objectStore("vitals");

      record.synced = 1;
      writeStore.put(record);
      // 🔥 Remove from pendingServices after successful sync
      const pending = JSON.parse(localStorage.getItem("pendingServices") || "[]");

      const updated = pending.filter(
        item =>
          !(
            item.patientId === record.patient_excel_id &&
            String(item.serviceId).toLowerCase() === "vitals"
          )
      );

      localStorage.setItem("pendingServices", JSON.stringify(updated));

      console.log("✅ Vitals synced:", payload.patient_excel_id);

    } catch (err) {
      console.error("❌ Vitals sync error:", err.response?.data || err.message);
    }
  }
}